import { render, staticRenderFns } from "./channelConfigure.vue?vue&type=template&id=71c5ac88&scoped=true"
import script from "./channelConfigure.vue?vue&type=script&lang=js"
export * from "./channelConfigure.vue?vue&type=script&lang=js"
import style0 from "./channelConfigure.vue?vue&type=style&index=0&id=71c5ac88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c5ac88",
  null
  
)

export default component.exports